import type {StudioAccessUser} from '../types'
import {api} from './apiClient'

export interface StudioAccessUserUpdate {
  areaId: string
  role?: string
  budgetBRL: number
  topupBalance: number
  modelIds: string[]
}

export const accessUsersService = {
  async list(): Promise<StudioAccessUser[]> {
    const response = await api.get<{users: StudioAccessUser[]}>('/access-users')
    return response.users
  },

  async update(guid: string, data: StudioAccessUserUpdate): Promise<StudioAccessUser> {
    const response = await api.put<{user: StudioAccessUser}>(
      `/access-users/${encodeURIComponent(guid)}`,
      data
    )
    return response.user
  },
}
